// extracted by mini-css-extract-plugin
module.exports = {"cardWrapper":"SearchResultCard_cardWrapper__21Izg"};